import React from 'react'
import { useFetch } from '../hooks/useFetch'
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'
export default function SelectSaProvince({ province, setProvince }) {

    const { error, isPending, data } = useFetch('https://dcregapi.bi-oss.co.za/shared/saprovincelist')
    return (
        <FormControl fullWidth>
            <InputLabel id="selectprovince">Select Province*</InputLabel>

            <Select


                labelId="province"
                id="province"

                onChange={(e) => setProvince(e.target.value)}
                input={<OutlinedInput label="selectprovince" />}
                required
                value={province}
            >
                {data && data.map(data => (

                    <MenuItem key={data.id} value={data.province}>{data.province}</MenuItem>
                ))}

            </Select>




        </FormControl>
    )
}
